import { Injectable } from '@angular/core';

import { UserRole } from '@/app/api/users';
import { AuthStore } from '@/app/core/store/auth';
import { ProfilePermission } from '@/app/api/profile';

@Injectable({
  providedIn: 'root',
})
export class PermissionsService {
  constructor(private readonly authStore: AuthStore) {}

  private get user() {
    return this.authStore.authUser();
  }

  hasPermissions(permissionToCheck: ProfilePermission | ProfilePermission[]): boolean {
    if (!this.user) {
      return false;
    }

    const permissions = new Set(this.user.permissions);

    if (Array.isArray(permissionToCheck)) {
      if (permissionToCheck.length === 0) {
        return false;
      }
      return permissionToCheck.every((permissionItem) => permissions.has(permissionItem));
    }

    return permissions.has(permissionToCheck);
  }

  hasRole(roleToCheck: UserRole) {
    return this.user?.role === roleToCheck;
  }

  hasAnyRoles(rolesToCheck: UserRole[]) {
    return !!this.user && rolesToCheck.includes(this.user.role);
  }
}
